import { render, staticRenderFns } from "./incapacidades.vue?vue&type=template&id=1703ebd8&scoped=true&"
import script from "./incapacidades.vue?vue&type=script&lang=js&"
export * from "./incapacidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1703ebd8",
  null
  
)

export default component.exports